module.exports = __webpack_public_path__ + "img/google.1cdc8fce.svg";